export default abstract class BaseAPI {
  APIBaseURl: string = process.env.DOTNET_API_URL;
  WPCacheBaseURL: string = 'https://cache.giveinkind.com/url';

  buildAPIEndPoint(endpoint: string): string {
    return this.APIBaseURl + endpoint;
  }

  buildWPCacheEndPoint(endpoint: string): string {
    return `${this.WPCacheBaseURL}/${encodeURIComponent(`https://cms.giveinkind.com/wp-json/wp/v2${endpoint}`)}`;
  }
}
